import { csrfToken } from '../../data/csrfToken';
import { http, HttpResponse } from 'msw';
import { apiUrl } from '../apiUrl';
import { CSRF_TOKEN_PATH } from '../../../slices/api.slice';

export const csrfTokenQuery = http.get(apiUrl(CSRF_TOKEN_PATH), () => {
    return HttpResponse.json(csrfToken);
});

export const sessionHandlers = [csrfTokenQuery];
